import { useEffect, useState } from 'react';

const useScrollPercent = () => {
  const [scrollPercent, setScrollPercent] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      setScrollPercent(scrollable > 0 ? Math.round((window.scrollY / scrollable) * 100) : 0);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return scrollPercent;
};

export default useScrollPercent;
